// gerenciando o cancelamento de execução de funções
const debounceQueue: any = {}

// tslint:disable-next-line:ban-types
export const debounce = (num: number, call: Function) =>
  (...args: any[]) => {
    const key = JSON.stringify(call)
    clearTimeout(debounceQueue[key])
    debounceQueue[key] = setTimeout(() => call(...args), num)
    return debounceQueue[key]
  }

export default {
  debounce
}
